import { Form, Card, Spin, Tag } from "antd";
import React, { Component } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import Page from "../general/Page";
import "./Accounts.css";
import "./AccountForm.css";
import "./UpdateAccountForm.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { handleError } from "../../utils/ErrorHandlers";
class ViewAccountForm extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("viewAccounts");
    this.state = {
      account: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      cfg: {},
      inputVisible: false,
      inputValue: "",
      tags: [],
    };
  }

  componentDidMount() {
    this.getAccountData();
  }
  async getAccountData() {
    let { id } = this.props.match.params;

    this.acc = new AccountService();
    try {
      this.setState({ isFetching: true });
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        id
      );

      var cfg = {};
      cfg.pkg_name = "";
      cfg.agents_max_num = "";
      cfg.account_numbers = [];

      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.max_concurrent_calls = element["MAX_CONCURRENT_CALLS"];
          }
          if (Object.getOwnPropertyNames(element).indexOf("agentsCount") > -1) {
            cfg.agentsCount = element["agentsCount"];
          }
          if (Object.getOwnPropertyNames(element).indexOf("adminsCount") > -1) {
            cfg.adminsCount = element["adminsCount"];
          }

          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_numbers = [];
            } else {
              cfg.account_numbers = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
        });
      }

      this.setState({
        account: account.ivrCustomEntityObject,
        isFetching: false,
        cfg: cfg,
        tags: cfg.account_numbers,
      });
    } catch (error) {
      this.setState({
        isFetching: false,
      });
      handleError(error);
    }
  }

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let { isFetching, tags } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("View Account")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    {/* {this.props.context.user.userType == "SUPER" && ( */}
                      <Form.Item label={t("Account Name")} {...formItemLayout}>
                        <label>{this.state.account.accountName} </label>
                      </Form.Item>
                    {/* )} */}

                    {/* {this.props.context.user.userType == "SUPER" && ( */}
                      {/* <Form.Item
                        label={t("Account Contact Name")}
                        {...formItemLayout}
                      >
                        <label>{this.state.account.accountContactName} </label>
                      </Form.Item> */}
                    {/* )} */}
                    <Form.Item
                      label={t("Account Contact Number")}
                      {...formItemLayout}
                    >
                      <label>
                        {this.state.account.accountContactNumber === ""
                          ? this.state.account.accountName
                          : this.state.account.accountContactNumber}{" "}
                      </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Account Contact Email")}
                      {...formItemLayout}
                    >
                      <label>{this.state.account.accountContactEmail} </label>
                    </Form.Item>

                    <Form.Item label={t("Account Status")} {...formItemLayout}>
                      {this.state.account.accountStatus === "ACT" ? (
                        <label>{t("Active")}</label>
                      ) : (
                        <label>{t("Suspended")}</label>
                      )}
                    </Form.Item>
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    ></Form.Item>

                    <Form.Item label={t("Current Package Code")} {...formItemLayout}>
                      <label>{this.state.cfg.pkg_name} </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Max Agents Number")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.agents_max_num} </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Max Concurrent Calls")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.max_concurrent_calls} </label>
                    </Form.Item>

                    <Form.Item label={t("Account Numbers")} {...formItemLayout}>
                      <div>
                        {tags.map((tag, index) => {
                          return <Tag key={tag}>{tag}</Tag>;
                        })}
                      </div>
                    </Form.Item>

                    <Form.Item
                      label={t("Number Of Agents")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.agentsCount} </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Number Of Admins")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.adminsCount} </label>
                    </Form.Item>

                    {this.state.account.billingId !== null ? (
                      <Form.Item label={t("Billing Id")} {...formItemLayout}>
                        <label>{this.state.account.billingId} </label>
                      </Form.Item>
                    ) : (
                      <></>
                    )}
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(ViewAccountForm))
);
